/* eslint-disable no-console */
import { getEnvVar } from './env';

const envPath =
  window.location.hostname === 'localhost' ? 'localhost' : window.location || 'defaultEnv';

const adminAppUrl = getEnvVar('REACT_APP_ADMIN_APP_URL') || envPath;

const appName =
  process.env.NODE_ENV === 'test'
    ? 'testEnv'
    : adminAppUrl
        .split('://')
        .slice(1)[0]
        .split('/')
        .slice(1)
        .filter((a) => a)
        .join('/');

export function getPrefixedKey(key) {
  if (typeof key !== 'string' || key.trim() === '') {
    console.error(`${key} Key must be a non-empty string`);
  }
  return `${appName}+${key}`;
}

const envLocalStorage = new Proxy(localStorage, {
  get(target, prop) {
    if (prop === 'setItem' || prop === 'getItem' || prop === 'removeItem') {
      return (key, ...args) => {
        return target[prop](getPrefixedKey(key), ...args);
      };
    }

    if (prop === 'clear') {
      return () => {
        const keysToRemove = [];
        for (let i = 0; i < target.length; i++) {
          const key = target.key(i);

          if (key.startsWith(`${appName}+`)) {
            keysToRemove.push(key);
          }
        }
        keysToRemove.forEach((key) => target.removeItem(key));
      };
    }

    if (typeof prop === 'string' && !(prop in target)) {
      const value = target.getItem(getPrefixedKey(prop));
      return value ?? null;
    }

    return target[prop];
  },
  set(target, prop, value) {
    if (typeof prop === 'string') {
      target.setItem(getPrefixedKey(prop), value);
      return true;
    }

    return false;
  },
});

Object.defineProperty(window, 'localStorage', {
  value: envLocalStorage,
  writable: false,
  configurable: false,
});
